// Helpers for use within React components to support UI testing

export const isUiTest = (): boolean =>
  // Checks if DAISIE_UI_TEST in env is `true` while running visual regression tests
  // Useful for skipping things like randomisation that would cause these tests to fail
  !!process.env.DAISIE_UI_TEST && process.env.DAISIE_UI_TEST === 'true';
